import { provideChameleonDesignSystem } from '../provideChameleonDesignSystem';
import { chameleonListbox } from './Listbox.definition';
import { chameleonListboxItem } from './ListboxItem/ListboxItem.definition';
import { chameleonInteractiveSubItem } from './InteractiveSubItem/InteractiveSubItem.definition';
import { chameleonTooltipV2 } from '../TooltipV2';
export function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonListbox({ prefix }), chameleonListboxItem({ prefix }), chameleonInteractiveSubItem({ prefix }), chameleonTooltipV2({ prefix }));
}
